import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MapView = ({ opportunities, onMarkerClick, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-background">
      <div className="h-full flex flex-col">
        <div className="bg-card border-b border-border p-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon name="Map" size={24} color="var(--color-primary)" />
            <div>
              <h2 className="text-lg font-semibold text-foreground">Map View</h2>
              <p className="text-sm text-muted-foreground">
                {opportunities?.length} opportunities in your area
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            aria-label="Close map view"
          >
            <Icon name="X" size={24} />
          </Button>
        </div>

        <div className="flex-1 relative">
          <iframe
            width="100%"
            height="100%"
            loading="lazy"
            title="Volunteer Opportunities Map"
            referrerPolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps?q=37.7749,-122.4194&z=12&output=embed"
            className="border-0"
          />

          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-card border border-border rounded-lg shadow-lg p-4 max-w-sm w-full mx-4">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="MapPin" size={24} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-foreground truncate">
                  Click markers to view opportunities
                </h3>
                <p className="text-sm text-muted-foreground">
                  Zoom and pan to explore more
                </p>
              </div>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                fullWidth
                iconName="List"
                iconPosition="left"
                onClick={onClose}
              >
                List View
              </Button>
              <Button
                variant="default"
                fullWidth
                iconName="Navigation"
                iconPosition="left"
              >
                My Location
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapView;